export default __webpack_public_path__ + "static/media/icon-success.bf7f9ad2.svg";